import React from 'react';
import { useNavigate } from 'react-router-dom';
import cns from 'classnames';
import pageData from '../../../common/talent/data.json';
import styles from './index.module.less';
import { Button } from 'antd';

function TalentPC() {
  const navigate = useNavigate();

  const handleRegister = () => {
    navigate('/project/application');
    // window.open('http://azalea-tech.mikecrm.com/S8juig5');
  };

  const renderPatrolling = () => (
    <div className={styles.Patrol}>
      <div className={styles.subtitle}>{pageData.patrol.title}</div>
      <div className={styles.content}>{pageData.patrol.topContent}</div>
      <img src={pageData.patrol.imgUrl} alt="" className={styles.Patrol__img} />
      <div className={styles.content}>{pageData.patrol.lastContent}</div>
    </div>
  );

  const renderCampaign = () => (
    <div className={styles.campaign}>
      <div className={styles.subtitle}>{pageData.campaign.title}</div>{' '}
      <img src={pageData.campaign.imgList[0]} alt="" className={styles.Patrol__img} />
      <div className={styles.content}>{pageData.campaign.content1}</div>
      <div className={styles.content}>{pageData.campaign.content2}</div>
      <img src={pageData.campaign.imgList[1]} alt="" className={styles.Patrol__img} />
      <div className={styles.content}>{pageData.patrol.lastContent}</div>
    </div>
  );

  const renderTeacher = () => (
    <div className={styles.teacher}>
      <div className={styles.subtitle}>{pageData.teacher.title}</div>
      <div className={styles.teacher__list}>
        {pageData.teacher.list.map((item, index) => (
          <div key={index} className={styles.teacher__list__item}>
            <img src={item.imgUrl} alt="" className={styles.teacher__list__item__img} />
            <div>{item.tips}</div>
          </div>
        ))}
      </div>
      <div className={styles.content}>{pageData.teacher.content}</div>
      <Button className={styles.teacher__register} onClick={handleRegister}>
        申请加入讲师团
      </Button>
    </div>
  );

  const renderCase = () => (
    <div className={styles.case}>
      {renderPatrolling()}
      {renderTeacher()}
      {renderCampaign()}
    </div>
  );

  return (
    <section className={styles.local}>
      <div className={styles.local__container}>{renderCase()}</div>
    </section>
  );
}

export default TalentPC;
